var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#7663EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2969 36C31.7791 36 31.3594 35.5803 31.3594 35.0625C31.3594 31.3922 28.3734 28.4062 24.7031 28.4062H23.2969C19.6266 28.4062 16.6406 31.3922 16.6406 35.0625C16.6406 35.5803 16.2209 36 15.7031 36C15.1853 36 14.7656 35.5803 14.7656 35.0625C14.7656 30.3584 18.5927 26.5312 23.2969 26.5312H24.7031C29.4073 26.5312 33.2344 30.3584 33.2344 35.0625C33.2344 35.5803 32.8147 36 32.2969 36Z",
    fill: "#7663EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 24.6562C20.4169 24.6562 17.5781 21.8175 17.5781 18.3281C17.5781 14.8388 20.4169 12 23.9062 12C27.3956 12 30.2344 14.8388 30.2344 18.3281C30.2344 21.8175 27.3956 24.6562 23.9062 24.6562ZM23.9062 13.875C21.4508 13.875 19.4531 15.8727 19.4531 18.3281C19.4531 20.7836 21.4508 22.7812 23.9062 22.7812C26.3617 22.7812 28.3594 20.7836 28.3594 18.3281C28.3594 15.8727 26.3617 13.875 23.9062 13.875Z",
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.0301ab34fae23c929840856cabf64b31.svg";
export { ForwardRef as ReactComponent };